module.exports = __webpack_public_path__ + "media/images/fundraise/fundraise-banner-8468e62e01612d9ca412ae7ada569af0.jpg";